module.exports = __webpack_public_path__ + "static/img/cont3604.8806400.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont3604.jpg
// module id = LyrJ
// module chunks = 0